import React from 'react'
import PropTypes from 'prop-types'

class DoMutation extends React.Component {
  componentDidMount() {
    this.props.mutate()
  }

  render() {
    if (typeof this.props.children === 'function') {
      return this.props.children()
    } else {
      return this.props.children
    }
  }
}

DoMutation.propTypes = {
  mutate: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
}

export default DoMutation
